import React, {FC} from 'react';
import {Button, Grid} from "@mui/material";
import { SidePanelContent, SidePanelFooter } from '@securspace/securspace-ui-kit';
import PaymentMethodType from "./PaymentMethodType";
import AuthorizationCard from "./AuthorizationCard";
import {
  PaymentModalContentWrap,
  PaymentModalSubtitle,
  PaymentModalWrapper,
} from "./styles/paymentModalStyle";

interface IPaymentModalBodyProps {
  payWithAch: boolean,
  setACH: (value: boolean) => void,
  setMicroDeposit: (value: boolean) => void,
  doneWithAddPaymentMethod: () => void,
  launchAddPaymentMethod: () => void,
  collectMicroDepositVerifyPayment: boolean,
  microDepositVerify?: boolean
}

const PaymentModalBody: FC<IPaymentModalBodyProps> = React.forwardRef((props, _ref) => {
  const {
    payWithAch,
    setACH,
    setMicroDeposit,
    doneWithAddPaymentMethod,
    launchAddPaymentMethod,
    collectMicroDepositVerifyPayment
  } = props;

  return <>
    <SidePanelContent>
      <PaymentModalContentWrap>
        <PaymentModalSubtitle variant={'h6'}>
          Select Payment Method
        </PaymentModalSubtitle>
        <Grid container spacing={2} alignItems="center">
          <PaymentModalWrapper item>
            <PaymentMethodType
              setACH={setACH}
              payWithAch={payWithAch}
              collectMicroDepositVerifyPayment={collectMicroDepositVerifyPayment}
              setMicroDeposit={setMicroDeposit}
            />
          </PaymentModalWrapper>
        </Grid>
      </PaymentModalContentWrap>
      <Grid container>
        <AuthorizationCard payWithAch={payWithAch}/>
      </Grid>
    </SidePanelContent>
    <SidePanelFooter>
      <Button variant='text' color='secondary' onClick={doneWithAddPaymentMethod}>
        Cancel
      </Button>
      <Button variant='text' color='secondary' onClick={launchAddPaymentMethod}>
        Agree & Continue
      </Button>
    </SidePanelFooter>
  </>
});

PaymentModalBody.displayName = 'PaymentModalBody';

export default PaymentModalBody;
